/* eslint-disable quote-props */
module.exports = {
  bind: {
    bindwb: '绑定微博',
    binddb: '绑定豆瓣',
    bindqq: '绑定qq',
    hasbind: '已绑定',
    yjbdwx: '一键绑定微信',
    bindway: '绑定以下任一种登录方式',
  },
  global: {
    'note-loading': '文章加载中',
    'content-loading': '内容加载中',
    quit: '按 Esc 退出',
    timeout: '请求超时',
    commit: '提交',
    cancel: '取消',
    setting: '设置',
    'to-home': '返回首页',
    'download': '下载简书App',
    'forbidden-desc': '很抱歉，网页版写文章功能暂不支持手机/平板电脑，你可以在简书 App 中使用',
    'load-more': '加载更多',
    'no-more-notes': '没有更多文章了',
    'loading': '加载中...',
  },
  'not-found': {
    'title': '您要找的页面不见了',
    'desc': '因为您的链接地址有误，链接地址为',
    'to-home': '返回「简书」首页',
  },
  'note-action': {
    'time-publish': '定时发布',
    'publicize': '直接发布',
    'publicized': '已发布',
    'compile-paid-note': '发布更新和设置',
    'publicize-paid-note': '发布为付费文章',
    'set-publicize-style': '设置发布样式',
    'topping-note': '置顶文章',
    'untopping-note': '取消置顶文章',
    'topping-success': '文章置顶成功',
    'untopping-success': '取消文章置顶成功',
    'share': '分享文章',
    'move-note': '移动文章',
    'open-in-new-window': '在新窗口打开',
    'private-note': '设为私密',
    'to-history': '历史版本',
    'del-note': '删除文章',
    'set-unreprintable': '设置禁止转载',
    'cancel-unreprintable': '取消禁止转载',
  },
  settings: {
    'change-read-mode': '阅读模式已切换成功',
    'change-locale': '显示语言已切换成功',
    'change-font': '显示字体已切换成功',
    'change-editor': '默认编辑器已切换成功',
    'display': '设置显示模式',
    'open-night-mode': '打开夜间模式',
    'close-night-mode': '关闭夜间模式',
    'change-to-song': '切换至宋体',
    'change-to-black': '切换至黑体',
    'change-to-simple': '切换至简体',
    'change-to-traditional': '切换至繁体',
    'editor': '默认编辑器',
    'md-editor': 'MarkDown编辑器',
    'rich-editor': '富文本编辑器',
    'recycle': '回收站',
    'feedback': '帮助与反馈',
    'need-help': '遇到问题',
    'common-issue': '常见问题',
    'on': '开',
    'off': '关',
    'sync-scroll': '同步滚动',
    'switch-sync-scroll': '同步滚动状态切换成功',
    'author-verfy': '简书作者实名认证',
  },
  grammar: {
    'grammar': 'Markdown语法参考',
    'h1': '# 一级标题',
    'h2': '## 二级标题',
    'h5': '##### 五级标题',
    'ul1': '- 列表第一项',
    'ul2': '- 列表第二项',
    'ol1': '1. 有序列表第一项',
    'ol2': '2. 有序列表第二项',
    'link': '[标题](链接地址)',
    'image': '![图片描述](图片链接地址)',
    'italic': '*斜体*',
    'bold': '**粗体**',
    'code-block': '> 引用段落',
    'blockquote': '```\n代码块\n```',
  },
  notebooks: {
    'to-homepage': '回首页',
    'new-notebook': '新建文集',
    'new-notebook-ing': '新建文集中...',
    'rename-notebook-tip': '请输入新文集名',
    'new-notebook-empty': '文集名不能为空',
    'del-notebook-tip': '确认删除文集《{name}》，文章将被移动到回收站。',
  },
  notes: {
    'audio': '音频',
    'new-note': '新建文章',
    'new-note-ing': '新建文章中...',
    'new-note-bottom': '在下方新建文章',
    'default-note-title': '无标题文章',
    'word-num': '字数:',
    'save-word': '{wordNum} 字',
    'move-note-success': '文章已移动至新文集',
    'del-note-confirm-tip': '确认删除文章《{title}》，文章将被移动到回收站，您可以在那里恢复它。60天后将被彻底删除。',
    'topping': '置顶',
  },
  'pay-note': {
    'i-agree': '我同意',
    'agree-title': '付费文章协议',
    'cancelbtn': '不同意',
    'okbtn': '同意',
    'step-title': '付费文章设置',
    'step-one': '设置试读范围',
    'step-one-des': '请你在右侧选择免费可读的部分',
    'step-two': '输入定价',
    'yuan': '元',
    'step-three': '设置音频',
    'pay-for-audio': '购买文章后才能播放',
    'free-for-audio': '免费播放',
    'confirming-btn': '发布中...',
    'confirm-btn': '确认并发布',
    'cancel-btn': '取消',
    'wrong-price': '请输入正确的金额({minnum}-{maxnum}元)',
    'price-tip': '您可自由设置文章定价，最低1元，最高2000元。',
    'mask-item-des': '该分割线以上免费可读',
    'publish-paid-notes': '发表付费文章',
    'publish-explain-1': '付费文章即读者付费后才可解锁阅读的文章，拥有付费文章发表权限的作者可以发表付费文章。',
    'publish-explain-2': '该功能仅针对「简书会员」或「简书钻大于 {minJSD}」或「被邀请」的用户开放，您可以通过购买简书会员快速获得该资格。',
    'about-jsd': '了解简书钻特权',
    'open-js-member': '开通简书会员',
  },
  'publish-setting': {
    'set-cover-img': '设置封面图，优化文章的显示效果',
    'set-note': '未设置则自动按默认样式显示',
    'choose-img-count': '选择图片数量',
    'one-img': '一图',
    'three-img': '三图（无摘要）',
    'upload-cover-img': '上传封面图',
    'click-to-upload': '点击上传',
    'upload-note1': '尺寸大于 360×360，格式 png/jpg',
    'upload-note2': '单张图片大于 440×320，格式 png/jpg',
    'change': '更换',
    'input-abstract': '输入摘要',
    'input-placeholder': '选填，30字内，如不填写会默认抓取首段内容',
    'confirm-btn': '保存',
    'confirming-btn': '保存中...',
    'cancel-btn': '取消',
    'preview': '效果预览',
    'preview-note': '仅供参考，具体效果会根据不同手机型号而变化',
    'save': '保存',
    'saving': '保存中...',
    'confirmed': '发布样式已更新',
    'notes-over-limit': '摘要字数超出限制！',
  },
  share: {
    'trailing-jianshushe': '- 简书社',
    'to-weibo': '微博',
    'to-qzone': 'QQ空间',
    'to-douban': '豆瓣',
    'to-wechat': '微信',
    'to-facebook': 'Facebook',
    'to-twitter': 'Twitter',
    'to-googleplus': 'Google+',
    'copy-link': '复制链接',
    'wechat-des': '打开微信“扫一扫”，打开网页后点击屏幕右上角分享按钮',
    more: '更多分享',
  },
  error: {
    'content-not-enough': '内容少于{num}段，不能发表为付费文章',
    'save-again-soft': '上一篇文章有内容未保存成功，需要手动保存',
    'save-again': '有内容未保存成功，确定要离开？',
    'data-empty': '暂无数据',
    'try-again': '操作失败，请再试一次',
    'content-no-empty': '内容不能为空',
    'link-no-empty': '链接不能为空',
    'text-no-empty': '文本不能为空',
    'file-not-exit': '文件不存在',
    'file-type-error': '图片格式错误，请使用jpg/jpeg/png/gif文件',
    'file-size-over': '文件大小超过{size}M',
    'need-bind-phone': '需要绑定手机号后才能发布文章哟~',
    'uploading-img': '正在上传图片，请稍等...',
    'video-max-over': '视频不能超过{num}个',
    'fail-refresh': '操作失败，可以刷新页面尝试',
    'upload-fail': '有图片未上传成功，请删除或重新上传图片。如需帮助，请',
    'click': '点击',
    'no-nb': '文集不存在',
  },
  tooltip: {
    bold: '粗体',
    italic: '斜体',
    strikethrough: '删除线',
    quote: '引用',
    picture: '插入图片',
    h1: '标题1',
    h2: '标题2',
    h3: '标题3',
    h4: '标题4',
    hr: '分割线',
    link: '插入链接',
    video: '插入视频',
    audio: '插入音频',
    audioExist: '已有音频',
    'math-formula': '数学公式',
    undo: '撤销',
    redo: '重做',
    history: '历史版本',
    save: '保存',
    expand: '全屏',
    compress: '退出全屏',
    preview: '切换到预览模式',
    'to-normal-mode': '返回',
    'grammar': 'Markdown语法参考',
    jianchuang: 'AI简创',
  },
  pubbtn: {
    publishing: '发布中...',
    saving: '保存中...',
    saved: '已保存',
    'save-fail': '保存失败,请手动保存',
    publicize: '发布文章',
    publicized: '已发布',
    'cancel-publish': '取消发布',
    'publish-update': '发布更新',
    'compile-paid-note': '发布更新和设置',
    'publicize-paid-note': '发布为付费文章',
    'audio-transcoding': '音频转码中，请稍后发布',
  },
  modal: {
    insertimg: '插入图片',
    insertlink: '插入链接',
    insertvideo: '插入视频',
    removeLink: '删除链接',
    confirm: '确认',
    cancel: '取消',
    urldes: '链接地址',
    'getting-linkinfo': '正在获取链接标题...',
    'getting-linkinfo-fail': '无法获取链接标题,请手动输入链接文本',
    linktxtdes: '链接文本',
    insertimgdes: '点击上传（可多张）',
    imgpolicy: '图片私密性',
    chooseurlimg: '或选择网络图片',
    imglinkdes: '请输入网络图片链接',
    choosesysimg: '或上传本地图片',
    'only-support': '目前只支持',
    tc: '腾讯',
    yk: '优酷',
    video: '视频',
    'video-url-des': '请输入视频地址',
    'wrong-video-source': '暂不支持此视频地址',
    'video-loading': '正在加载视频，请稍等...',
    'fetch-video-info-failed': '抱歉，您输入的地址无法识别！',
    'insert-audio': '插入音频',
    'upload-audio': '点击上传',
    'audio-support': '支持 {format} 格式，大小不超过 {size} M',
    'audio-cancle': '取消上传',
    'audio-upload-unfinished': '音频上传尚未完成',
    'reupload-audio': '重新上传',
    'retry': '重试',
    'audio-upload-failed': '上传失败',
    'audio-uploading-failed': '音频未上传成功',
    'audio-upload-complete': '上传完成',
    'audio-upload-error': '网络异常，请稍后再试',
    'audio-name': '音频名称',
    'audio-author': '音频作者',
    'insert-audio-name': '输入音频名称',
    'insert-audio-author': '输入音频的创作者',
    'delete-audio': '删除音频',
    'audio-confirm': ' 确定',
    'audio-overlarge': '文件大小超过限制！',
    'audio-delete': '确认删除音频吗？',
    'no-name': '佚名',
    'close-audio-warning': '确认关闭吗？',
    'close-audio-warning2': '关闭后，当前的更改或上传将丢失',
    'audio-transcoding': '音频正在转码，请稍候',
    'audio-edit': '编辑',
    'insert-math-formula': '插入数学公式',
    'common-expression': '常用表达式',
    'common-function': '常用函数',
    'common-symbol': '常用符号',
    'greek-alphabet': '希腊字母',
    'special-symbol': '特殊符号',
    'math-formula-grammar': '数学公式语法',
    'insert-empty': '输入内容为空，请重新输入！',
    'insert-audio-modal': '插入音频',
    'insert-audio-explain': '插入音频功能，仅对简书钻大于 {minJSD} 或被邀请的用户开放，你可以通过购买简书会员，或者积极参与简书社区互动（喜欢优质文章/喜欢自己的文章）等方式，增加你的简书钻',
  },
  history: {
    'auto-save': '自动保存',
    publicize: '公开发表文章',
    update: '发布更新',
    recovery: '版本恢复',
    web: '简书网站',
    ios: '简书 iPhone App',
    android: '简书 Android App',
    'ios-night': '简书 iPhone App 黑夜版',
    timeago: '刚刚_秒以前_分钟以前_小时以前_天以前_周以前_月以前_年以前',
    'total-items': '共{num}条历史版本',
    filter: '筛选',
    'recovery-to': '恢复到这个版本',
  },
  trash: {
    trash: '回收站({num})',
    recovery: '恢复文章',
    recovering: '恢复文章中...',
    delete: '彻底删除',
    deleting: '彻底删除中...',
    'del-time': '将于{time}清除',
    'del-time2': '{time}天后清除',
  },
  verifymodal: {
    'sending-captcha': '{num}秒后重新发送',
    'resend-captcha': '重新发送验证码',
    'send-captcha': '发送验证码',
    'empty-captcha': '验证码为空',
    'verify-captcha-error': '验证码错误，请重试',
    'send-captcha-error': '验证码发送失败，可刷新页面重试',
    loading: '正在加载验证信息...',
    confirm: '确认',
    confirming: '确认中...',
    captcha: '验证码',
    title: '安全验证',
    'email-prefix': '用邮箱',
    'sms-prefix': '用手机',
    verify: '验证',
    'by-email': '用邮箱验证',
    'by-phone': '用手机短信验证',
    des: '为了保证你的账号安全，请先验证身份，验证成功后进行下一步操作，验证码{minute}分钟内有效',
  },
  app: {
    name: '简 书',
  },
  phoneModal: {
    all: '全部',
    clickbind: '点击绑定',
    bindtitle: '绑定手机号和微信',
    wxoccupy: '微信被占用',
    bindwx: '綁定微信',
    bindwxtip: '请使用微信扫描二维码进行绑定',
    nobind: '未绑定',
    bindwxphone: '绑定手机号和微信',
    yjjb: '一键绑定',
    cancel: '取消',
    bindtip: '发布公开文章需要同时绑定手机号和微信',
    'tip': '绑定遇到问题',
    'href': '点击查看帮助',
    'hot-countries': '热门国家和地区',
    'captcha-regex-error': '验证码格式不对，请重新输入',
    captcha: '短信验证码',
    title: '绑定手机',
    'phone-num': '手机号',
    'phone-error': '输入的手机号码有误，请重新输入',
    'get-otp-info-error': '获取国家区号失败, 请刷新页面重试',
  },
  publishSuccessModal: {
    'post-des': '向专题投稿，让文章被更多人发现',
    'success-des': '发布成功，点击查看文章',
    'search-collection': '搜索专题',
    'new-collection': '新建',
    'my-collections': '我管理的专题',
    'lastest-collections': '最近投稿',
    'recomend-collections': '推荐专题',
    'include-note': '收录',
    'including-note': '收录中',
    'included-note': '已收录',
    'post-note': '投稿',
    'posting-note': '投稿中',
    'posted-note': '等待审核',
    'copy-success': '已复制到剪贴板中',
    'get-more-data': '点击加载更多',
    'no-more-data': '没有更多了',
    'copy-fail': '此浏览器不支持，复制失败，建议用Chrome',
  },
  collections: {
    'note-num': '{num}篇文章',
    'suber-num': '{num}人关注',
  },
  'upload-img': {
    'upload-success': '上传成功',
    'upload-fail': '上传失败',
    'upload-size-error': '上传图片尺寸错误',
    'upload-net-error': '网络错误，请重试',
  },
  tips: {
    'set-reprintable-success': '设置转载状态成功',
    'set-reprintable-fail': '设置转载状态失败',
  },
};


// WEBPACK FOOTER //
// ./src/constants/locales/zh-CN.js